import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Card, Accordion, Button } from "react-bootstrap";
import { FaGlobeAmericas, FaRegGem, FaBullseye } from "react-icons/fa";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./Whybarsana.css";

const valuesData = [
  {
    title: "The Divine Legacy of Barsana",
    content:
      "A Land Steeped in Spirituality Welcome to Barsana: The Sacred Abode of Radha Rani Nestled in the heart of Uttar Pradesh's Braj region, Barsana is a town that resonates with divine love and timeless spirituality. Revered as the birthplace of Goddess Radha, the eternal consort of Lord Krishna, Barsana is a jewel of Hindu pilgrimage and cultural heritage. This historic town, located just 46 km from Mathura, is surrounded by four sacred hills symbolizing the four heads of Lord Brahma, earning it the ancient name Brahmasarin. For over 5,000 years, Barsana has captivated the hearts of devotees and travelers with its mystical charm and serene landscapes.A Tapestry of Myth and History Barsana's history is woven with legends of divine love. According to mythology, King Vrishabhanu, Radha's father, made Bhanugarh Hill his home, where the iconic Radha Rani Temple now stands. Established by King Vajranabh, Krishna's great-grandson, around 5,000 years ago, the temple was later rediscovered and rebuilt in 1675 AD by Raja Bir Singh Deo in majestic Rajput style. The town's winding lanes echo tales of Radha and Krishna's playful childhood, their divine Raas Leela, and their eternal bond, making Barsana a living testament to their love. Cultural Vibrance and Festive Splendor Barsana is synonymous with its vibrant festivals, particularly Lathmar Holi and Laddu Holi, which draw global attention. During Lathmar Holi, women playfully chase men with sticks, reenacting Krishna's teasing of Radha, while Laddu Holi sees sacred sweets thrown from the Radha Rani Temple as prasad. Celebrated with unmatched fervor, these festivals, along with Radhashtami and Krishna Janmashtami, transform Barsana into a kaleidoscope of colors and devotion, offering residents a front-row seat to India's richest cultural traditions. Why Barsana for Your Dream Home? Choosing Barsana for your residence is an invitation to live amidst divine serenity and cultural richness. Our 32-acre premium township, adorned with exquisite landscaping by one of India's most celebrated artists, blends modern luxury with Barsana's spiritual essence. Here, every sunrise over the sacred hills promises peace, and every festival fills your home with joy. Welcome to a lifestyle where divinity meets elegance.",
  },
  {
    title: " Unique Features of Barsana ",
    content:
      "A Blend of Nature and DivinitySacred Landmarks and Spiritual Sanctuaries Barsana is a treasure trove of sacred sites that inspire awe and devotion. The Radha Rani Temple, perched atop Bhanugarh Hill, is the town's crown jewel. Built with red sandstone in Rajput architectural style, it features intricate carvings, vibrant murals of Radha-Krishna's love story, and a gilded statue of Radha alongside Krishna. Nearby, the Ladliji Temple (built in 1675) and Kirti Temple, dedicated to Radha's mother, offer serene spaces for worship. The Prem Sarovar, a sacred lake believed to be the meeting place of Radha and Krishna, and Pila Pokhar, a reservoir tied to their childhood, add to the town's mystical allure. Natural Beauty and Scenic Hills Surrounded by Brahma, Vishnu, Shiva, and Shesha Hills, Barsana is a haven of natural beauty. These four peaks, each crowned with a temple, create a picturesque backdrop that soothes the soul. The lush greenery, rolling landscapes, and tranquil ponds make Barsana ideal for those seeking a peaceful retreat from urban chaos. The town's location along the Agra-Delhi National Highway (NH-44) and proximity to the Yamuna Expressway ensures seamless connectivity to Delhi (124 km) and Agra (102 km), blending rural charm with urban accessibility. A Community Rooted in Tradition Barsana's close-knit community, with a population of approximately 11,184 (2011 Census), thrives on its spiritual and cultural heritage. The Yadav community, historically tied to cowherding, infuses the town with warmth and tradition. With a literacy rate of 69.88%, higher than the state average, Barsana balances its ancient roots with modern aspirations, making it an ideal setting for families seeking a harmonious lifestyle. Your Premium Oasis in Barsana ur township redefines luxury living in this sacred land. Spanning 32 acres, it features top-tier landscaping crafted by a renowned Indian artist, transforming your home into a masterpiece of design and nature. With gated security, 24/7 utilities, lush parks, and a dedicated temple within the township, your residence in Barsana offers unmatched tranquility and sophistication, perfectly complementing the town's divine ambiance.",
  },
  {
    title: "Future Growth of Barsana",
    content:
      "A Rising Star in Spiritual TourismA Booming Pilgrimage Destination Barsana's significance as a key stop in the Krishna pilgrimage circuit, alongside Mathura, Vrindavan, anp Govardhan, ensures a steady influx of devotees and tourists. Millions visit annually to experience its temples, festivals, and sacred sites, driving demand for quality infrastructure and residential spaces. The town's proximity to major tourist hubs like Agra (Taj Mahal) and Delhi positions it as a prime destination for both domestic and international travelers, fueling economic growth. Real Estate Potential The real estate market in Barsana is on an upward trajectory, driven by its spiritual allure and improved connectivity. Projects like the Armed Forces Welfare Housing Organisation's Shri Bhankey Bihari Township highlight the demand for plotted developments with modern amenities. Our 32-acre township, with its premium positioning and artistic landscaping, is poised to attract discerning buyers seeking exclusive residences in a spiritually significant location. The affordability of land, compared to urban centers, makes Barsana an attractive investment opportunity. Economic and Cultural Momentum Barsana's festivals, particularly Lathmar Holi, have gained global recognition, boosting local commerce and tourismrelated businesses. The town's integration into the Braj region's cultural ecosystem, supported by events like Radhashtami and Krishna Janmashtami, ensures year-round vibrancy. As more visitors flock to Barsana, the demand for high-end residential and hospitality infrastructure will soar, making our township a visionary investment for the future. A Future-Ready LifestyleOur township is designed to capitalize on Barsana's growth while offering residents a lifestyle of unparalleled luxury. With world-class amenities, sustainable design, and proximity to sacred sites, it caters to those who value spirituality, culture, and modernity. As Barsana evolves into a global spiritual hub, your home in our township will be at the forefront of this transformation, offering both emotional fulfillment and financial returns.",
  },
  {
    title:
      "Government Developments and the Future of BarsanaEco-Restoration and Tourism Boost",
    content:
      "The Uttar Pradesh government is committed to elevating Barsana's status as a premier spiritual and eco-tourism destination. A landmark eco-restoration project, launched in 2025, aims to transform the dry hills surrounding Barsana into lush green landscapes. Starting with the 98-hectare Rakauli Hill, the initiative includes extensive plantation, water conservation, and cultural revitalization efforts. This project is expected to enhance Barsana's aesthetic appeal, attract eco-tourists, and reinforce its spiritual significance, making it an even more desirable place to live. Infrastructure and Connectivity Enhancements The government's focus on improving connectivity is set to transform Barsana's accessibility. The Yamuna Expressway already connects Barsana to Delhi and Agra in just 2 hours, while regular bus services and proximity to Mathura Junction (46 km) ensure seamless travel. Plans to upgrade road networks and public transport will further integrate Barsana with the National Capital Region (NCR), driving residential and commercial development. Cultural and Spiritual Investments The UP Tourism Department is actively promoting Barsana as part of the Braj region's heritage circuit. Investments in preserving sacred sites, enhancing festival infrastructure, and developing tourist facilities are underway. These efforts will amplify Barsana's global appeal, drawing more pilgrims and cultural enthusiasts. Nearby areas like Vrindavan and Govardhan are also benefiting from similar initiatives, creating a vibrant regional ecosystem that elevates Barsana's prominence. Your Home in Barsana's Bright Future Our 32-acre township is strategically positioned to thrive amidst these transformative developments. With breathtaking landscapes designed by a leading artist, stateof-the-art amenities, and a location steeped in divinity, it offers a rare opportunity to own a piece of Barsana's promising future. Join us in crafting a legacy where luxury meets spirituality, and your home becomes a sanctuary in the land of Radha Rani.",
  },
];

const facts = [
  {
    text: "Why Own a Home in Barsana?",
    value:
      "Reconnect with your inner self in an environment that promotes peace, prayer, and positivity.Ideal for spiritual seekers, senior citizens, and anyone looking for a peaceful retreat from city chaos.",
  },
  {
    text: "Rising Pilgrimage Tourism Hub",
    value:
      "With increasing footfall from domestic and international devotees, Barsana is now becoming a real estate hotspot.Government initiatives under the Braj Development Plan are boosting infrastructure and connectivity in the region.",
  },
  {
    text: "Affordable and Appreciating Land",
    value:
      "Property prices are still relatively lower compared to Vrindavan and Mathura, but rapidly rising due to development. Excellent opportunity for early investors and second home buyers.",
  },
  {
    text: "Connectivity & Proximity",
    value:
      "Just 45 km from Mathura, 20 km from Govardhan, and 140 km from Delhi. Accessible via Yamuna Expressway and Agra–Delhi highway. New spiritual corridors and road widening projects are underway.",
  },
  {
    text: "Blissful Living Amid Nature",
    value:
      "Surrounded by verdant hills, sacred groves (vanas), and serene temples, Barsana offers unmatched tranquility. The air feels blessed, the water is sacred, and every sunrise is a divine experience.",
  },
];

export default function WhyChooseUs() {
  const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const VIDEO_BASE_URL = process.env.REACT_APP_Video_BASE_URL;
  const [expanded, setExpanded] = useState(
    valuesData.reduce((acc, _, i) => ({ ...acc, [i]: true }), {})
  );

  const handleToggle = (i) =>
    setExpanded((prev) => ({ ...prev, [i]: !prev[i] }));

  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  };

  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0 });

  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0 });
    } else {
      controls.start({ opacity: 0, y: -50 });
    }
  }, [inView, controls]);

  const funFactsRef = useRef(null);

  // ✅ FIXED toggle function
  const toggle = (index) => {
    setExpanded((prev) => {
      const updated = { ...prev };
      updated[index] = !updated[index];

      setTimeout(() => {
        if (updated[index]) {
          document.getElementById(`accordion-body-${index}`)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 300);

      return updated;
    });
  };

  const logos = [
    "/image/RPS.png",
    "/image/logooo.png",
    "/image/omaxe.png",
    "/image/RPS.png",
    "/image/brand.png",
    "/image/omaxe.png",
    "/image/logooo.png",
    "/image/RPS.png",
  ];

  return (
    <>
      <section id="home-section" className="home-hero">
        <div className="hero-container text-white">
          {/* Background Video */}
          <video
            className="bg-video"
            // src="/video/oatfoundation.mp4"
            src={`${VIDEO_BASE_URL}/shri2.mp4`}
            type="video/mp4"
            preload="auto"
            muted
            loop
            playsInline
            autoPlay
            webkit-playsinline="true"
          ></video>

          {/* Overlay Content */}
          <div
            id="overlay-left"
            className="overlay-left d-flex align-items-center justify-content-center text-center"
            style={{
              position: "relative",
              zIndex: 1,
              minHeight: "100vh",
            }}
          >
            <div className="container">
              <div className="col-md-8 mx-auto">
                {/* Fade Up Animation for Heading */}
                <motion.h1
                  id="heading"
                  className="fw-bold display-4 mb-3"
                  style={{ color: "#fff", letterSpacing: "1px" }}
                  initial={{ opacity: 0, y: 40 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                >
                  Barsana- The Soul Of Spiritual India
                </motion.h1>

                {/* Fade Up Animation for Paragraph */}
                <motion.p
                  id="subheading"
                  className="lead34"
                  initial={{ opacity: 0, y: 40 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
                >
                  Barsana is a realm of profound spirituality, revered as the
                  holy birthplace of Radha Rani and the very ground where
                  celestial love took root. This sacred city stands testament to
                  centuries-old tales of Radha and Krishna, their timeless,
                  celestial romance steeped in every grain of its history. To
                  live here is to reside amidst that eternal narrative. Now,
                  Aanandam Valleey presents a unique and blessed opportunity to
                  build your dream home and establish your legacy within this
                  transcendent spiritual landscape.
                </motion.p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="why-container">
        <div className="container">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Why Choose Us</h2>
          </div>
          <div className="row whybarsana">
            <div className="col-md-6">
              <img
                src={`${IMAGE_BASE_URL}/first.png`}
                className="img-fluid mb-4"
              />
            </div>
            <div className="col-md-6">
              <div className="mytext">
                <h3>Future Growth of Barsana</h3>
                <p>
                  Aanandam Valleey is strategically positioned at the core of
                  the Barsana-Vrindavan-Mathura circuit, a region undergoing an
                  unprecedented transformation backed by massive government
                  investment. This push for modernization and heritage
                  preservation is setting the stage for sustained, high-value
                  economic and tourism growth.{" "}
                </p>
                <p>
                  <b>The ₹32,000 Crore Growth Catalyst</b>
                </p>
                <p>
                  The region's future is defined by the ₹32,000 Crore Braj 2041
                  Masterplan, a comprehensive strategy to establish Vrindavan
                  and the surrounding areas, including Barsana, as a global
                  spiritual and economic powerhouse. This plan projects over 9
                  Crore+ annual visitors by 2024, capitalizing on the region's
                  immense popularity.
                </p>
                <p>
                  Government funding is significantly boosting connectivity and
                  access across the Braj region:
                </p>
                <div class="table-container">
                  <div className="table-responsive">
                    <table>
                      <thead>
                        <tr>
                          <th>Project</th>
                          <th>Allocation</th>
                          <th>Impact</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <b>84 Kos Parikrama Marg</b>
                            <br></br>
                            (275 km)
                          </td>
                          <td>
                            <b>₹5,000 Crore</b>
                          </td>
                          <td>
                            Ensures seamless regional and spiritual movement.
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Vrindavan Bypass & Waterway</b>
                          </td>
                          <td>
                            <b>₹1,645 Cr + ₹395 Cr</b>
                          </td>
                          <td>
                            Decongests towns and enhances eco-mobility (Yamuna
                            Waterway).
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Braj Tourism & Eco-restoration</b>
                          </td>
                          <td>
                            <b>₹206 Crore</b>
                          </td>
                          <td>
                            Direct investment in environmental and tourism
                            infrastructure.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br></br>

          <center>
            <p>
              <b> Exponential Tourism and Enterprise Growth </b>
            </p>
            <p>
              The data confirms a decisive, post-pandemic surge, translating
              directly into high-potential enterprise growth in the area:
            </p>
          </center>
          <div className="text-aftable">
            <li>
              {" "}
              <b>Massive Footfall: </b>The Braj district registers{" "}
              <b>~90 million annual tourists</b>, on a confirmed upward trend.
            </li>
            <li>
              <b> Accelerated Growth:</b> Tourist visits to the Barsana region
              are accelerating at an estimated annual rate of{" "}
              <b>10−15% or more </b>
              (double-digit growth).
            </li>
            <li>
              <b>Enterprise Boom: </b>The tourist sector (homestays, guides)
              experienced <b>+60−70% growth</b> between 2018 and 2023,
              validating the surging demand for local hospitality.
            </li>
          </div>

          {/* <div className="row whybarsana2">

            <div className="col-md-6">
              <div className="mytext2">
                <h3>The Divine Legacy of Barsana</h3>
                <p>Cultural Vibrance and Festive Splendor Barsana is synonymous with its vibrant festivals, particularly
                   Lathmar Holi and Laddu Holi, which draw global attention. During Lathmar Holi, women playfully chase
                    men with sticks, reenacting Krishna's teasing of Radha, while Laddu Holi sees sacred sweets thrown
                     from the Radha Rani Temple as prasad. Celebrated with unmatched fervor, these festivals, along with 
                     Radhashtami and Krishna Janmashtami, transform Barsana into a kaleidoscope of colors and devotion,
                      offering residents a front-row seat to India's richest cultural traditions. Why Barsana for Your
                       Dream Home? Choosing Barsana for your residence is an invitation to live amidst divine serenity
                        and cultural richness. Our 32-acre premium township, adorned with exquisite landscaping by one 
                        of India's most celebrated artists, blends modern luxury with Barsana's spiritual essence. Here,
                         every sunrise over the sacred hills promises peace, and every festival fills your home with joy. 
                         Welcome to a lifestyle where divinity meets elegance.</p>
              </div>
            </div>
            <div className="col-md-6">
              <img src="image/second.png" className="img-fluid" />
            </div>
          </div> */}
        </div>

        {/* <section className="roji">
          <Container>


            <Accordion
              id="why-choose-us"
              alwaysOpen
              defaultActiveKey={valuesData.map((_, i) => i.toString())}
            >
              {valuesData.map((item, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>{item.title}</Accordion.Header>
                  <Accordion.Body
                    id={`accordion-body-${index}`}
                    className="my-accordion-body"
                  >
                    <div
                      className={
                        expanded[index] ? "clamp-collapsed" : "clamp-expanded"
                      }
                    >
                      <span className="typewriter-text">{item.content}</span>
                    </div>
                    <div className="read-more-box mt-3">
                      <Button
                        variant="link"
                        className="p-0 read-toggle"
                        onClick={() => toggle(index)}
                      >
                        {expanded[index] ? "Read more" : "Read less"}
                      </Button>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Container>
        </section> */}

        {/* <section className="youtube-section">
          <div className="video-wrapper">
            <iframe
              className="background-video"
              src="https://www.youtube.com/embed/1ovIKzSpNQk?controls=0&rel=0&autoplay=1&mute=1&loop=1&playlist=1ovIKzSpNQk&playsinline=1"
              title="Background Video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
          </div>

          <div className="content-overlay text-center text-white">
            <h2 className="headline">Your New property is Just a Click Away!</h2>
            <a
              href="#"
              className="btn  mt-3"
              style={{ background: "#103C3B", color: "white" }}
            >
              Get Started
            </a>
          </div>
        </section> */}

        {/* <div id="mybrandsslider">
          <h2>Brand That Trust Us</h2>
          <div className="slide-track">
            {logos.concat(logos).map((logo, i) => (
              <div className="slide" key={i}>
                <img src={logo} alt="brand logo" className="logo" />
              </div>
            ))}
          </div>
        </div> */}

        {/* </div> */}
      </section>
      <br></br>
    </>
  );
}
